<template>
    <div class="patient-records-container">
        <!-- Patient Information Section -->
        <div class="patient-info-section">
            <div class="form-row">
                <div class="form-group">
                    <label>نام بیمار</label>
                    <input type="text" v-model="patientInfo.name" placeholder="نام بیمار" disabled
                        class="disabled-input" />
                </div>
                <div class="form-group">
                    <label>تاریخ مراجعه</label>
                    <span class="custom-date">
                        <div class="p-date" style="width: 100% !important; border: none !important">
                            <DatePicker v-model="patientInfo.visitDate" format="jYYYY/jMM/jDD"
                                display-format="jYYYY/jMM/jDD" :editable="true" auto-submit
                                placeholder="تاریخ را وارد یا انتخاب کنید" />
                        </div>
                        <BaseButton
                            v-if="patientInfo.visitDate"
                            type="button"
                            class="clear-date-btn"
                            variant="compact"
                            title="X"
                            @click="patientInfo.visitDate = ''"
                        />
                    </span>
                </div>
                <div class="form-group">
                    <label>نام پزشک</label>
                    <select v-model="patientInfo.doctorId">
                        <option value="">انتخاب پزشک</option>
                        <option v-for="doctor in doctors" :key="doctor.fDauto" :value="doctor.fDauto">
                            {{ doctor.fDname }} - {{ doctor.fDtakhasos }}
                        </option>
                    </select>
                </div>
            </div>
            <!-- Attachment Buttons Section -->

            <div class="attachment-buttons-section">
                <BaseButton class="attachment-btn" title="توضیحات متنی" variant="outline" @click="openTextDescriptionModal()">
                    <template #icon>
                        <font-awesome-icon :icon="['fas', 'file-alt']" />
                    </template>
                </BaseButton>

                <BaseButton class="attachment-btn" title="قلم نوری" variant="outline" @click="openOpticalPenModal()">
                    <template #icon>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                            <path d="M2 22h20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </template>
                </BaseButton>

                <BaseButton class="attachment-btn file-btn" title="تصویر و فایل ضمیمه" variant="outline" @click="openAttachementModal()">
                    <template #icon>
                        <font-awesome-icon :icon="['fas', 'paperclip']" />
                    </template>
                </BaseButton>

                <BaseButton class="attachment-btn" title="دوربین" variant="outline" @click="openCameraModal()">
                    <template #icon>
                        <font-awesome-icon :icon="['fas', 'camera']" />
                    </template>
                </BaseButton>
                <!-- <button class="attachment-btn" @click="openScanModal()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 4h18v2H3V4zm0 4h18v8H3V8zm2 2h14v4H5v-4zm4-6h6v2H9V4zm0 4h6v2H9V8z" />
                        <circle cx="7" cy="11" r="1" />
                        <circle cx="11" cy="11" r="1" />
                        <circle cx="15" cy="11" r="1" />
                        <circle cx="7" cy="13" r="1" />
                        <circle cx="11" cy="13" r="1" />
                        <circle cx="15" cy="13" r="1" />
                    </svg>

                    <span>اسکن</span>
                </button> -->
                <!-- <button class="attachment-btn" @click="openPatientKarteks()">
                    <font-awesome-icon :icon="['fas', 'file-medical']" />


                    <span>کارتکس بیمار</span>
                </button> -->
                <BaseButton class="attachment-btn" title="ضبط صدا" variant="outline" @click="openVoiceModal()">
                    <template #icon>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                            <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                        </svg>
                    </template>
                </BaseButton>


                <div v-if="isTextEditorOpen" class="modal-overlay">
                    <div class="modal-content">
                        <div class="modal-sub-header">
                            <div class="sub-header">
                                <ModalHeader>
                                    <template #default>
                                        <h3>توضیحات متنی</h3>
                                    </template>
                                    <template #actions>
                                        <BaseButton title="ذخیره" variant="primary" @click="saveTextDescription" />
                                        <BaseButton title="انصراف" variant="cancel" @click="closeTextEditor" />
                                    </template>
                                </ModalHeader>
                            </div>
                            <hr class="divider-line" />
                            <TextEditorModal :isOpen="isTextEditorOpen" :mainContent="mainContent"
                                :recordId="savabeghRecordId" ref="textEditorRef" />
                        </div>
                    </div>
                </div>
                <!-- <button class="attachment-btn" @click="openBeforeAfter()">
                    <font-awesome-icon :icon="['fas', 'images']" />
                    <span>قبل و بعد</span>
                </button> -->
                <BaseButton class="attachment-btn" title="تعهد نامه" variant="outline" @click="openCommitmentForm()">
                    <template #icon>
                        <font-awesome-icon :icon="['fas', 'file-signature']" />
                    </template>
                </BaseButton>
                <BaseButton class="attachment-btn" title="سوابق بستری" variant="outline" @click="openHospitalizationHistory()">
                    <template #icon>
                        <font-awesome-icon :icon="['fas', 'bed-pulse']" />
                    </template>
                </BaseButton>
            </div>
            <div v-if="currentFiles && currentFiles.length">
                <div class="image-upload-area">
                    <div class="image-placeholder">
                        <div class="thumbnails">
                            <div v-for="(file, index) in currentFiles" :key="index" class="thumbnail-item"
                                @click="viewFile(file, index)">
                                <!-- تصویر -->
                                <img v-if="isImage(file)" :src="getFileUrl(file)" class="thumbnail-img" />

                                <!-- ویدیو -->
                                <video v-else-if="isVideo(file)" :src="getFileUrl(file)" class="thumbnail-img"
                                    muted></video>

                                <!-- صدا -->
                                <div v-else-if="isAudio(file)" class="icon-center">
                                    <font-awesome-icon :icon="['fa-solid', 'file-audio']" size="2x" />
                                </div>

                                <!-- PDF -->
                                <div v-else-if="isPDF(file)" class="icon-center">
                                    <font-awesome-icon :icon="['fa-solid', 'file-pdf']" size="2x" />
                                </div>

                                <!-- سایر فایل‌ها -->
                                <div v-else class="icon-center">
                                    <font-awesome-icon :icon="['fa-solid', 'file']" size="2x" />
                                </div>

                                <!-- حذف -->
                                <BaseButton class="delete-file-btn" @click.stop="deletePhoto(index)" shape="circle" size="sm" variant="ghost">
                                    <template #icon>
                                        <font-awesome-icon :icon="['fa-solid', 'trash-can']" />
                                    </template>
                                </BaseButton>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- Filter and Search Section -->
            <div class="filter-section">
                <div class="date-filter">
                    <label>فیلتر</label>
                    <div class="date-range">
                        <div class="date-input-group">
                            <span class="custom-date">
                                <div class="p-date" style="width: 100% !important; border: none !important">
                                    <DatePicker v-model="fromDate" format="jYYYY/jMM/jDD" display-format="jYYYY/jMM/jDD"
                                        :editable="true" auto-submit placeholder="از تاریخ" />
                                </div>
                                <BaseButton type="button" v-if="fromDate" @click="fromDate = ''" class="clear-date-btn" size="sm" shape="circle" variant="ghost" title="پاک کردن تاریخ">
                                    <template #icon>&times;</template>
                                </BaseButton>
                            </span>
                        </div>
                        <div class="date-input-group">
                            <span class="custom-date">
                                <div class="p-date" style="width: 100% !important; border: none !important">
                                    <DatePicker v-model="toDate" format="jYYYY/jMM/jDD" display-format="jYYYY/jMM/jDD"
                                        :editable="true" auto-submit placeholder="تا تاریخ" />
                                </div>
                                <BaseButton type="button" v-if="toDate" @click="toDate = ''" class="clear-date-btn" size="sm" shape="circle" variant="ghost" title="پاک کردن تاریخ">
                                    <template #icon>&times;</template>
                                </BaseButton>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="search-input">
                    <input type="text" v-model="searchQuery" placeholder="جستجو..." />
                    <BaseButton v-if="searchQuery" @click="clearSearch" class="clear-search" size="sm" shape="circle" variant="ghost">
                        <template #icon>
                            <font-awesome-icon :icon="['fas', 'times']" />
                        </template>
                    </BaseButton>
                </div>
                <div class="full-records-section">
                    <BaseButton title="مشاهده کامل سوابق" variant="primary" @click="viewFullRecords" />
                </div>
            </div>

            <!-- Attachments Table -->
            <div class="attachments-table-section">
                <BaseTable
                    :items="records"
                    :empty-colspan="6"
                >
                    <template #empty>
                        موردی برای نمایش وجود ندارد.
                    </template>

                    <template #head>
                        <tr>
                            <th>ردیف</th>
                            <th>نوع فایل</th>
                            <th>توضیحات</th>
                            <th>تاریخ</th>
                            <th>ساعت</th>
                            <th>عملیات</th>
                        </tr>
                    </template>

                    <template #row="{ item: record, index }">
                        <td data-label="ردیف">{{ index + 1 }}</td>
                        <td data-label="نوع فایل">{{ record.contentTypeName }}</td>
                        <td data-label="توضیحات">{{ record.fSdesc || '-' }}</td>
                        <td data-label="تاریخ">{{ record.fStxdate }}</td>
                        <td data-label="ساعت">{{ record.fStxtime }}</td>
                        <td class="actions-cell" data-label="عملیات">
                            <button
                                class="action-btn edit"
                                @click="record.fStype == 0 ? openTextEditor(record.fSradif, record.fSdesc) : (record.fStype == 2 ? viewAttachment(record) : (isAudioFile(record) ? openAudioPlayer(record) : downloadAttachment(record)))"
                                aria-label="ویرایش"
                            >
                                <img src="/img/edit.svg" alt="ویرایش" />
                            </button>
                            <button class="action-btn delete" @click="deletePatientRecordItem(record.fSradif, index)" aria-label="حذف">
                                <img src="/img/trash.svg" alt="حذف" />
                            </button>
                        </td>
                    </template>
                </BaseTable>
            </div>

            <!-- مدال قلم نوری -->
            <div v-if="showOpticalPenModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-sub-header">
                        <div class="sub-header">
                            <ModalHeader>
                                <template #default>
                                    <h3>قلم نوری</h3>
                                </template>
                                <template #actions>
                                    <BaseButton title="ذخیره" variant="primary" @click="handleConfirmOpticalPen({ recordId: currentRecordId, photos: [], isEditing: false, description: '' })" />
                                    <BaseButton title="انصراف" variant="cancel" @click="closeOpticalPenModal" />
                                </template>
                            </ModalHeader>
                        </div>
                        <hr class="divider-line" />
                        <DrawingCapture :recordId="currentRecordId" :editingFile="editingFile" ref="drawingCaptureRef"
                            @close="closeOpticalPenModal" />
                    </div>
                </div>
            </div>

            <!-- مدال دوربین -->
            <div v-if="showCameraModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-sub-header">
                        <div class="sub-header">
                            <ModalHeader>
                                <template #default>
                                    <div class="header-title-container">
                                        <h3>دوربین</h3>
                                    </div>
                                </template>
                                <template #actions>
                                        <BaseButton title="ذخیره" variant="primary" @click="handleConfirmCamera" />
                                    <BaseButton title="انصراف" variant="cancel" @click="closeCameraModal" />
                                </template>
                            </ModalHeader>
                        </div>
                    </div>
                    <hr class="divider-line" />
                    <CameraCapture :recordId="currentRecordId" @confirm="handleConfirmCamera" ref="cameraCaptureRef"
                        @close="closeCameraModal" />
                </div>
            </div>

            <!-- مدال الصاق فایل -->
            <div v-if="showAttachementModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-sub-header">
                        <div class="sub-header">
                            <ModalHeader>
                                <template #default>
                                    <div class="header-title-container">
                                        <h3>تصویر و فایل ضمیمه</h3>
                                    </div>
                                </template>
                                <template #actions>
                                    <BaseButton title="ذخیره" variant="primary" @click="handleAttachementConfirm" />
                                    <BaseButton title="انصراف" variant="cancel" @click="closeAttachementModal" />
                                </template>
                            </ModalHeader>
                        </div>
                    </div>
                    <hr class="divider-line" />
                    <PatientUploadFile :patientId="currentRecordId" @confirm="handleAttachementConfirm"
                        ref="uploadFileRef" @close="closeAttachementModal" />
                </div>
            </div>

            <!-- مدال ضبط صدا -->
            <div v-if="showVoiceRecorderModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-sub-header">
                        <div class="sub-header">
                            <ModalHeader>
                                <template #default>
                                    <h3>ضبط صدا</h3>
                                </template>
                                <template #actions>
                                    <BaseButton title="ذخیره" variant="primary" @click="handleVoiceConfirm" />
                                    <BaseButton title="انصراف" variant="cancel" @click="closeVoiceModal" />
                                </template>
                            </ModalHeader>
                        </div>
                    </div>
                    <hr class="divider-line" />
                    <VoiceRecorder :patientId="currentRecordId" @confirm="handleVoiceConfirm" @close="closeVoiceModal"
                        ref="voiceRecorderRef" />
                </div>
            </div>

            <!-- مدال اسکن -->
            <div v-if="showScanModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-sub-header">
                        <div class="sub-header">
                            <ModalHeader>
                                <template #default>
                                    <div class="header-title-container">
                                        <h3>اسکن اسناد</h3>
                                    </div>
                                </template>
                                <template #actions>
                                    <BaseButton title="ثبت" variant="primary" @click="handleScanConfirm" />
                                    <BaseButton title="انصراف" variant="cancel" @click="closeScanModal" />
                                </template>
                            </ModalHeader>
                        </div>
                    </div>
                    <hr class="divider-line" />
                    <ScannerCapture :patientId="currentRecordId" @confirm="handleScanConfirm" @close="closeScanModal" />
                </div>
            </div>

            <!-- مدال الصاق تصویر -->
            <div v-if="showModal" class="modal-overlay">
                <div class="modal-content">
                    <ModalHeader>
                        <template #default>
                            <template v-if="!showConfirmModal">
                                <h3>الصاق تصویر برای : {{ currentRecordTitle }}</h3>
                            </template>
                            <template v-else>
                                <h3>تأیید حذف</h3>
                            </template>
                        </template>
                    </ModalHeader>

                    <ModalAddPhoto v-if="!showConfirmModal && currentRecordId" :recordId="currentRecordId"
                        @confirm="handleConfirm" @close="handleClose" />

                    <!-- confirmation content -->
                    <div v-if="showConfirmModal" class="confirm-content">
                        <p>{{ confirmMessage }}</p>
                        <div class="confirm-buttons">
                            <BaseButton class="btn-confirm" title="بله، حذف شود" variant="danger" @click="onConfirm(true)" />
                            <BaseButton class="btn-cancel" title="خیر" variant="cancel" @click="onConfirm(false)" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- مدال حذف رکورد -->
            <div v-if="showModalDeletePatientRecord" class="modal-overlay">
                <div class="modal-content">
                    <ModalHeader>
                        <template #default>
                            <template v-if="!showConfirmPatientRecordModal">
                                <h3>{{ currentRecordTitle }}</h3>
                            </template>
                            <template v-else>
                                <h3>تأیید حذف</h3>
                            </template>
                        </template>
                    </ModalHeader>

                    <!-- confirmation content -->
                    <div v-if="showConfirmPatientRecordModal" class="confirm-content">
                        <p>{{ confirmMessage }}</p>
                        <div class="confirm-buttons">
                            <BaseButton class="btn-confirm" title="بله، حذف شود" variant="danger" @click="onConfirmPatientSavabegh(true)" />
                            <BaseButton class="btn-cancel" title="خیر" variant="cancel" @click="onConfirmPatientSavabegh(false)" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- نمایش بزرگ تصویر (اختیاری) -->
            <div v-if="showPreview" class="preview-overlay" @click="showPreview = false">
                <img :src="previewSrc" class="large-photo" />
            </div>

            <div v-if="showPreviewFile" class="preview-overlay" @click="showPreviewFile = false">
                <img v-if="file.type === 'image'" :src="file.url" alt="Image" class="large-photo" />
                <a v-else :href="file.url" :download="file.name">دانلود فایل</a>
            </div>

            <div v-if="showAudioModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-sub-header">
                        <div class="sub-header">
                            <ModalHeader>
                                <template #default>
                                    <div class="header-title-container">
                                        <h3>فایل صوتی</h3>
                                    </div>
                                </template>
                                <template #actions>
                                    <BaseButton class="cancel-btn" title="بستن" variant="cancel" @click="closeAudioModal" />
                                </template>
                            </ModalHeader>
                        </div>
                    </div>
                    <hr style="
              width: 100%;
              padding: 0px;
              margin: 0px auto;
              margin-bottom: 10px;
              border: none;
              border-top: 1px solid rgba(var(--text-color-secondary-rgb), 0.15);
              background-color: transparent;
            " />
                    <AudioPlayerModal :show="showAudioModal" :audioData="selectedAudio" @close="closeAudioModal" />
                </div>
            </div>

            <!-- مودال نمایش کامل سوابق -->
            <div v-if="showFullRecordsModal" class="modal-overlay">
                <div class="full-records-modal-content">
                    <ModalHeader>
                        <template #default>
                            <h3>مشاهده کامل سوابق بیمار</h3>
                        </template>
                        <template #actions>
                            <BaseButton class="print-btn" title="چاپ" variant="outline" @click="printFullRecords">
                                <template #icon><font-awesome-icon :icon="['fas', 'print']" /></template>
                            </BaseButton>
                            <BaseButton class="close-btn" shape="circle" size="sm" variant="ghost" @click="closeFullRecordsModal">
                                <template #icon>&times;</template>
                            </BaseButton>
                        </template>
                    </ModalHeader>
                    
                    <div class="full-records-content">
                        <div v-if="records.length === 0" class="no-records">
                            هیچ سابقه ای برای نمایش وجود ندارد
                        </div>
                        
                        <div v-else class="records-grid">
                            <div v-for="(record, index) in records" :key="record.fSradif" class="record-item">
                                <div class="record-header">
                                    <span class="record-number">{{ index + 1 }}</span>
                                    <span class="record-type">{{ record.contentTypeName }}</span>
                                    <span class="record-date">{{ record.fStxdate }} - {{ record.fStxtime }}</span>
                                </div>
                                
                                <div class="record-content">
                                    <!-- نمایش توضیحات متنی -->
                                    <div v-if="record.fStype === 0 && record.fSdesc" class="text-content">
                                        <h4>توضیحات:</h4>
                                        <p>{{ record.fSdesc }}</p>
                                    </div>
                                    
                                    <!-- نمایش تصاویر -->
                                    <div v-if="record.fStype === 2" class="image-content">
                                        <h4>تصویر:</h4>
                                        <div class="image-container">
                                            <div class="image-preview-wrapper">
                                                <div class="image-placeholder" v-if="!recordImages[record.fSradif]">
                                                    <font-awesome-icon :icon="['fas', 'image']" />
                                                    <span>بارگذاری تصویر...</span>
                                                </div>
                                                <img v-else :src="recordImages[record.fSradif]" alt="تصویر سابقه" @error="onImageError(record.fSradif)" />
                                            </div>
                                            <div v-if="recordImages[record.fSradif]" class="image-buttons">
                                                <BaseButton class="zoom-btn" @click="viewAttachment(record)">
                                                    <template #icon>
                                                        <font-awesome-icon :icon="['fas', 'search-plus']" />
                                                    </template>
                                                </BaseButton>
                                                <BaseButton class="download-btn" @click="downloadAttachment(record)" variant="outline">
                                                    <template #icon>
                                                        <font-awesome-icon :icon="['fas', 'download']" />
                                                    </template>
                                                </BaseButton>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- نمایش فایل های صوتی -->
                                    <div v-if="isAudioFile(record)" class="audio-content">
                                        <h4>فایل صوتی:</h4>
                                        <div class="audio-buttons">
                                            <BaseButton class="play-audio-btn" @click="openAudioPlayer(record)">
                                                <template #icon>
                                                    <font-awesome-icon :icon="['fas', 'play']" />
                                                </template>
                                            </BaseButton>
                                            <BaseButton class="download-btn" @click="downloadAttachment(record)" variant="outline">
                                                <template #icon>
                                                    <font-awesome-icon :icon="['fas', 'download']" />
                                                </template>
                                            </BaseButton>
                                        </div>
                                    </div>
                                    
                                    <!-- نمایش سایر فایل ها -->
                                    <div v-if="record.fStype > 0 && !isAudioFile(record) && record.fStype !== 2" class="file-content">
                                        <h4>فایل ضمیمه:</h4>
                                        <div class="file-buttons">
                                            <BaseButton class="download-btn" @click="downloadAttachment(record)" variant="outline">
                                                <template #icon>
                                                    <font-awesome-icon :icon="['fas', 'download']" />
                                                </template>
                                            </BaseButton>
                                        </div>
                                    </div>
                                    
                                    <!-- نمایش نقاشی قلم نوری -->
                                    <div v-if="record.contentTypeName === 'نقاشی' || record.fStype === 1" class="drawing-content">
                                        <h4>نقاشی قلم نوری:</h4>
                                        <div class="image-container">
                                            <div class="drawing-preview-wrapper">
                                                <div class="image-placeholder" v-if="!recordImages[record.fSradif]">
                                                    <font-awesome-icon :icon="['fas', 'palette']" />
                                                    <span>بارگذاری نقاشی...</span>
                                                </div>
                                                <img v-else :src="recordImages[record.fSradif]" alt="نقاشی قلم نوری" @error="onImageError(record.fSradif)" />
                                            </div>
                                            <div v-if="recordImages[record.fSradif]" class="image-buttons">
                                                <BaseButton class="zoom-btn" @click="viewAttachment(record)">
                                                    <template #icon>
                                                        <font-awesome-icon :icon="['fas', 'search-plus']" />
                                                    </template>
                                                </BaseButton>
                                                <BaseButton class="download-btn" @click="downloadAttachment(record)" variant="outline">
                                                    <template #icon>
                                                        <font-awesome-icon :icon="['fas', 'download']" />
                                                    </template>
                                                </BaseButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="record-actions">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed, watch } from 'vue'
import { usePatientsStore } from '@/stores/clinic/patients';
import { useToast } from 'vue-toastification';
import ModalAddPhoto from './ModalAddPhoto.vue';
import TextEditorModal from './TextEditorModal.vue';
import DatePicker from 'vue3-persian-datetime-picker';
import moment from 'jalali-moment';
import DrawingCapture from './DrawingCapture.vue';
import CameraCapture from './CameraCapture.vue';
import PatientUploadFile from './PatientUploadFile.vue';
import VoiceRecorder from './VoiceRecorder.vue';
import ScannerCapture from './ScannerCapture.vue';
import { useDoctorsStore } from '@/stores/clinic/doctors';
import { useSavabeghStore } from '@/stores/clinic/Savabegh';
import AudioPlayerModal from './AudioPlayerModal.vue'
import ModalHeader from '@/components/ModalHeader.vue'
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
import BaseTable from '@/components/UiCompunents/BaseTable.vue'

// New reactive data for the redesigned interface
const patientInfo = ref({
    name: '',
    visitDate: moment().format('jYYYY/jMM/jDD'),
    doctorName: '',
    doctorId: 0,
    diagnosis: ''
})

const fromDate = ref('')
const toDate = ref('')
const searchQuery = ref('')

const showAudioModal = ref(false)
const selectedAudio = ref(null)
// Sample attachments data
const attachments = ref([
    { id: 1, type: 'تصویر', date: '1404/07/20', time: '14:30' },
    { id: 2, type: 'فایل', date: '1404/07/19', time: '10:15' },
    { id: 3, type: 'صوت', date: '1404/07/18', time: '16:45' }
])

// Legacy variables (keeping for compatibility)
const photosByRecordId = ref({})
const showModal = ref(false)
const showAttachementModal = ref(false)
const showOpticalPenModal = ref(false)
const showCameraModal = ref(false)
const showVoiceRecorderModal = ref(false)
const showScanModal = ref(false)
const showConfirmModal = ref(false)
const showModalDeletePatientRecord = ref(false)
const showConfirmPatientRecordModal = ref(false)
const currentRecordId = ref(null)
const savabeghRecordId = ref(null)
const mainContent = ref(null)
const currentRecordTitle = ref(null)
const selectedPhoto = ref(null);
const selectedPatientPhoto = ref(null);
const records = ref([])
const recordRefs = ref([])
const confirmMessage = ref('')
const pendingDelete = ref(null)
const file = ref(null);
const drawingCaptureRef = ref(null);
const cameraCaptureRef = ref(null);
const uploadFileRef = ref(null);
const voiceRecorderRef = ref(null);
const textEditorRef = ref(null);
const doctors = ref([]);

const showPreview = ref(false);
const showPreviewFile = ref(false);
const showFullRecordsModal = ref(false);
const previewSrc = ref("");
const editingFile = ref(null);
const recordImages = ref({});

// ✅ تشخیص نوع فایل
const isImage = (file) => {
    if (file instanceof File) return file.type.startsWith("image/");
    if (typeof file === "string") return file.startsWith("data:image/") || /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(file);
    return false;
};

const isVideo = (file) => {
    if (file instanceof File) return file.type.startsWith("video/");
    if (typeof file === "string") return file.startsWith("data:video/") || /\.(mp4|mov|avi|mkv)$/i.test(file);
    return false;
};

const isAudio = (file) => {
    if (file instanceof File) return file.type.startsWith("audio/");
    if (typeof file === "string") return file.startsWith("data:audio/") || /\.(mp3|wav|ogg)$/i.test(file);
    return false;
};

const isPDF = (file) => {
    if (file instanceof File) return file.type === "application/pdf";
    if (typeof file === "string") return file.startsWith("data:application/pdf") || /\.pdf$/i.test(file);
    return false;
};


// ✅ گرفتن URL موقت برای نمایش
const getFileUrl = (file) =>
    typeof file === "string" ? file : URL.createObjectURL(file);


// eslint-disable-next-line no-undef
const props = defineProps({
    patientId: { type: Number, required: true }
})
const files = ref({}) // تغییر از آرایه به object
const loadingPhotos = ref({})

// computed property برای نمایش فایل‌های فعلی
const currentFiles = computed(() => {
    // همیشه فایل‌های recordId = 0 را نمایش بده (فایل‌های PatientRecords)
    const result = files.value[0] || [];
    console.log('currentFiles computed:', result);
    return result;
});

// --- Store Setup ---
const doctorStore = useDoctorsStore();
const { fetchDoctorForCombo } = doctorStore;
const patientsStore = usePatientsStore();
const {
    getPatientRecords,
    getPatientRecordPhotos,
    savePatientRecordPhotos,
    deletePatientRecordPhoto,
    deletePatientRecord,
    getPatientById,
    getSavabeghFile,
    deleteSavabegh
} = patientsStore;
const savabeghStore = useSavabeghStore();
const { addSavabegh, updateSavabegh } = savabeghStore;
// --- Toast Setup ---
const toast = useToast();

const filteredAttachments = computed(() => {
    let filtered = attachments.value;

    if (fromDate.value || toDate.value) {
        filtered = filtered.filter(attachment => {
            const attachmentDate = attachment.date;
            if (fromDate.value && toDate.value) {
                return attachmentDate >= fromDate.value && attachmentDate <= toDate.value;
            } else if (fromDate.value) {
                return attachmentDate >= fromDate.value;
            } else if (toDate.value) {
                return attachmentDate <= toDate.value;
            }
            return true;
        });
    }

    if (searchQuery.value) {
        filtered = filtered.filter(attachment =>
            attachment.type.toLowerCase().includes(searchQuery.value.toLowerCase())
        );
    }

    return filtered;
});

const clearSearch = () => {
    searchQuery.value = '';
};

// نمایش کامل سوابق - باز کردن مودال
const viewFullRecords = async () => {
    showFullRecordsModal.value = true;
    // بارگذاری تصاویر سوابق
    await loadRecordImages();
};

// بستن مودال نمایش کامل سوابق
const closeFullRecordsModal = () => {
    showFullRecordsModal.value = false;
};

// چاپ سوابق کامل
const printFullRecords = () => {
    // ایجاد پنجره جدید برای چاپ
    const printWindow = window.open('', '_blank');
    
    // ساخت محتوای چاپی
    let printHTML = `
        <!DOCTYPE html>
        <html dir="rtl">
        <head>
            <meta charset="utf-8">
            <title>سوابق کامل بیمار</title>
            <style>
                body {
                    font-family: 'IRANSansWeb', Arial, sans-serif;
                    direction: rtl;
                    margin: 20px;
                    line-height: 1.6;
                }
                .header {
                    text-align: center;
                    margin-bottom: 30px;
                    border-bottom: 2px solid var(--text-color-thirdly);
                    padding-bottom: 20px;
                }
                .patient-info {
                    margin-bottom: 30px;
                    font-size: 16px;
                }
                .record-item {
                    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
                    margin-bottom: 20px;
                    padding: 15px;
                    border-radius: 8px;
                    page-break-inside: avoid;
                }
                .record-header {
                    background: var(--background-color-secondary);
                    padding: 10px;
                    margin: -15px -15px 15px -15px;
                    border-bottom: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
                    font-weight: bold;
                }
                .record-content h4 {
                    color: var(--text-color-primary);
                    margin: 10px 0 5px 0;
                }
                .text-content p {
                    background: var(--background-color-secondary);
                    padding: 10px;
                    border-radius: 4px;
                    margin: 10px 0;
                }
                img {
                    max-width: 300px;
                    max-height: 200px;
                    margin: 10px 0;
                    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
                }
                .image-placeholder {
                    background: var(--background-color-button2);
                    padding: 20px;
                    text-align: center;
                    border: 1px dashed rgba(var(--text-color-secondary-rgb), 0.3);
                    margin: 10px 0;
                }
                @media print {
                    body { margin: 10px; }
                    .record-item { page-break-inside: avoid; }
                }
            </style>
        </head>
        <body>
            <div class="header">
                <h1>سوابق کامل بیمار</h1>
            </div>
            <div class="patient-info">
                <strong>نام بیمار:</strong> ${patientInfo.value.name || 'نامشخص'}<br>
                <strong>تاریخ چاپ:</strong> ${new Date().toLocaleDateString('fa-IR')}
            </div>
    `;
    
    // اضافه کردن تمام سوابق
    records.value.forEach((record, index) => {
        printHTML += `
            <div class="record-item">
                <div class="record-header">
                    ${index + 1}. ${record.contentTypeName} - ${record.fStxdate} ${record.fStxtime}
                </div>
                <div class="record-content">
        `;
        
        // توضیحات متنی
        if (record.fStype === 0 && record.fSdesc) {
            printHTML += `
                <h4>توضیحات:</h4>
                <div class="text-content">
                    <p>${record.fSdesc}</p>
                </div>
            `;
        }
        
        // تصاویر
        if (record.fStype === 2) {
            printHTML += `<h4>تصویر:</h4>`;
            if (recordImages.value[record.fSradif]) {
                printHTML += `<img src="${recordImages.value[record.fSradif]}" alt="تصویر سابقه" />`;
            } else {
                printHTML += `<div class="image-placeholder">تصویر در دسترس نیست</div>`;
            }
        }
        
        // نقاشی قلم نوری
        if (record.contentTypeName === 'نقاشی' || record.fStype === 1) {
            printHTML += `<h4>نقاشی قلم نوری:</h4>`;
            if (recordImages.value[record.fSradif]) {
                printHTML += `<img src="${recordImages.value[record.fSradif]}" alt="نقاشی قلم نوری" />`;
            } else {
                printHTML += `<div class="image-placeholder">نقاشی در دسترس نیست</div>`;
            }
        }
        
        // فایل های صوتی
        if (isAudioFile(record)) {
            printHTML += `<h4>فایل صوتی:</h4><p>فایل صوتی ضبط شده</p>`;
        }
        
        // سایر فایل ها
        if (record.fStype > 0 && !isAudioFile(record) && record.fStype !== 2) {
            printHTML += `<h4>فایل ضمیمه:</h4><p>فایل پیوست شده</p>`;
        }
        
        printHTML += `
                </div>
            </div>
        `;
    });
    
    printHTML += `
        </body>
        </html>
    `;
    
    // نوشتن محتوا و چاپ
    printWindow.document.write(printHTML);
    printWindow.document.close();
    
    // صبر برای لود شدن تصاویر و سپس چاپ
    setTimeout(() => {
        printWindow.print();
        printWindow.close();
    }, 1000);
};

// دریافت پیش نمایش تصویر سابقه
const getRecordImagePreview = async (record) => {
    try {
        if (record.fStype === 2 || record.contentTypeName === 'نقاشی') {
            const fileData = await getSavabeghFile(record.fSpauto, record.fSradif);
            if (fileData && fileData.url) {
                return fileData.url;
            }
        }
        return '';
    } catch (error) {
        console.error('Error loading image preview:', error);
        return '';
    }
};

// بارگذاری تصاویر سوابق
const loadRecordImages = async () => {
    for (const record of records.value) {
        if (record.fStype === 2 || record.contentTypeName === 'نقاشی') {
            if (!recordImages.value[record.fSradif]) {
                try {
                    const fileData = await getSavabeghFile(record.fSpauto, record.fSradif);
                    if (fileData && fileData.url) {
                        recordImages.value[record.fSradif] = fileData.url;
                    }
                } catch (error) {
                    console.error('Error loading image for record:', record.fSradif, error);
                }
            }
        }
    }
};

// خطا در بارگذاری تصویر
const onImageError = (recordId) => {
    console.error('Failed to load image for record:', recordId);
    // می‌توانید placeholder خطا نمایش دهید
};

const deleteAttachment = async (record) => {
    const index = records.value.findIndex(att => att.fSradif === record.fSradif);
    if (index > -1) {
        records.value.splice(index, 1);
    }
    await deleteSavabegh(record.fSradif);
};

const editAttachment = (id) => {
    // Implementation for editing attachment
    console.log('Edit attachment:', id);
};

const viewAttachment = async (record) => {
    file.value = await getSavabeghFile(record.fSpauto, record.fSradif);
    showPreviewFile.value = true;
};
const downloadAttachment = async (record) => {
    try {
        const fileData = await getSavabeghFile(record.fSpauto, record.fSradif);

        if (!fileData) return;

        // برای فایل‌های تصویری، صوتی و ویدیویی نمایش مستقیم
        if (fileData.type === "image" || fileData.type === "video") {
            openFileInNewTab(fileData);
        }

        // برای PDF نمایش در تب جدید
        else if (fileData.type === "pdf") {
            openFileInNewTab(fileData);
        }
        // برای سایر فایل‌ها دانلود مستقیم
        else {
            downloadFileDirectly(fileData);
        }
    } catch (error) {
        console.error("Error in downloadAttachment:", error);
        toast.error("خطا در دریافت فایل");
    }
};
// استفاده از متد فعلی برای پلیر صوت
const openAudioPlayer = async (record) => {
    try {
        // استفاده از متد موجود شما - بدون هیچ تغییری
        const fileData = await getSavabeghFile(record.fSpauto, record.fSradif);

        if (fileData && fileData.type === 'audio') {
            selectedAudio.value = fileData;
            showAudioModal.value = true;
        } else {
            toast.error('این فایل صوتی نیست');
        }
    } catch (error) {
        console.error('Error opening audio player:', error);
        toast.error('خطا در بارگذاری فایل صوتی');
    }
}
// تابع برای نمایش فایل در تب جدید
const openFileInNewTab = (fileData) => {
    const newTab = window.open(fileData.url, '_blank');
    if (!newTab) {
        toast.warning("لطفاً اجازه باز کردن پنجره جدید را بدهید");
        // اگر باز کردن تب جدید مسدود شد، نمایش در همین صفحه
        const link = document.createElement("a");
        link.href = fileData.url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

// تابع برای دانلود مستقیم فایل
const downloadFileDirectly = (fileData) => {
    const link = document.createElement("a");
    link.href = fileData.url;
    link.download = fileData.name;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // آزاد کردن حافظه بعد از دانلود
    setTimeout(() => {
        URL.revokeObjectURL(fileData.url);
    }, 1000);
};
const closeAudioModal = () => {
    showAudioModal.value = false
    selectedAudio.value = null
}

const isAudioFile = (record) => {
    // منطق تشخیص فایل صوتی
    return record.contentType?.startsWith('audio/') ||
        record.fileName?.endsWith('.mp3') ||
        record.fileName?.endsWith('.m4a') ||
        record.fileName?.endsWith('.wav')
}
const openCameraModal = () => {
    currentRecordId.value = 0; // همیشه 0 چون در PatientRecords هستیم
    showCameraModal.value = true;
};

const closeCameraModal = () => {
    showCameraModal.value = false;
    currentRecordId.value = null;
};


const openScanModal = () => {
    currentRecordId.value = 0; // همیشه 0 چون در PatientRecords هستیم
    showScanModal.value = true;
};

const closeScanModal = () => {
    showScanModal.value = false;
    currentRecordId.value = null;
};

const openVoiceModal = () => {
    currentRecordId.value = 0; // همیشه 0 چون در PatientRecords هستیم
    showVoiceRecorderModal.value = true;
};

const closeVoiceModal = () => {
    showVoiceRecorderModal.value = false;
    currentRecordId.value = null;
};

// --- Stub actions for new buttons next to Voice Recorder ---
const openPatientKarteks = () => {
    toast.info('کارتکس بیمار');
};

const openBeforeAfter = () => {
    toast.info('قبل و بعد');
};

const openCommitmentForm = () => {
    toast.info('تعهد نامه');
};

const openHospitalizationHistory = () => {
    toast.info('سوابق بستری');
};

// --- Methods ---
const loadPatientInfo = async () => {
    const patient = await getPatientById(props.patientId);
    if (patient) {
        patientInfo.value.name = `${patient.fNamefami}`;
    }
}

const loadDoctorCombo = async () => {
    try {
        doctors.value = await fetchDoctorForCombo();
        const defaultDoctor = doctors.value.find(doctor => doctor.isDefault === true);
        if (defaultDoctor) {
            patientInfo.value.doctorId = defaultDoctor.fDauto;
        }
    } catch (error) {
        console.error("Error loading doctors:", error);
    }
}

const loadRecords = async () => {
    records.value = await getPatientRecords(props.patientId);
    // await nextTick()
    // observeRecords()
}

function handleConfirm({ recordId, photos }) {
    if (!photosByRecordId.value[recordId]) {
        photosByRecordId.value[recordId] = photos
    } else {
        photosByRecordId.value[recordId].push(...photos)
    }
    showModal.value = false
}


function handleClose() {
    showModal.value = false
    showConfirmModal.value = false
}

function viewPatientPhoto(recordId, index) {
    selectedPatientPhoto.value = { recordId, index }
}

function viewPhoto(recordId, index) {
    selectedPhoto.value = { recordId, index }
}

function deletePhoto(index) {
    if (files.value[0]) {
        files.value[0].splice(index, 1);
    }
}

const loadPhotos = async (recordId) => {
    if (files.value[recordId]) return
    loadingPhotos.value[recordId] = true
    try {
        console.log(recordId)
        var resDataphotos = await getPatientRecordPhotos(recordId);
        files.value[recordId] = resDataphotos
    } finally {
        loadingPhotos.value[recordId] = false
    }
}

async function savePatientRecordPhoto(recordId, recordPhotoList) {
    for (let i = 0; i < recordPhotoList.length; i++) {
        let file = recordPhotoList[i]

        if (typeof file === 'string' && file.startsWith('data:image')) {
            file = dataURLtoBlob(file)
        }

        const formData = new FormData()
        formData.append('photo', file, 'photo.jpg')
        formData.append('record_id', recordId)

        await savePatientRecordPhotos(formData)
    }
    files.value[recordId] = null
    await loadPhotos(recordId)

    if (photosByRecordId.value[recordId]) {
        photosByRecordId.value[recordId] = []
    }

}
async function deletePatientRecordItem(recordId, index) {
    confirmMessage.value = "آیا از حذف این رکورد اطمینان دارید؟";
    pendingDelete.value = { recordId, index };
    showConfirmPatientRecordModal.value = true;
    showModalDeletePatientRecord.value = true; // نمایش مودال اصلی
}
// --- تابع اصلاح شده برای حذف عکس ---
async function deletePatientRecordPhotoItem(photoId, recordId, index) {
    // نمایش confirmation modal
    confirmMessage.value = "آیا از حذف این عکس اطمینان دارید؟";
    pendingDelete.value = { photoId, recordId, index };
    showConfirmModal.value = true;
    showModal.value = true; // نمایش مودال اصلی
}
// تابع confirmation
const onConfirmPatientSavabegh = async (result) => {
    showConfirmPatientRecordModal.value = false;
    showModalDeletePatientRecord.value = false;

    if (result && pendingDelete.value) {
        try {
            const { recordId, index } = pendingDelete.value;
            await deleteSavabegh(recordId);
            console.log(recordId);
            console.log(index);
            if (records.value[recordId]) {
                records.value[recordId].splice(index, 1)
            }
        } catch (error) {
            console.error("Error deleting photo:", error)
            toast.error("خطا در حذف");
        }
        loadRecords();
        pendingDelete.value = null;
    }
}
// تابع confirmation
const onConfirm = async (result) => {
    showConfirmModal.value = false;
    showModal.value = false;

    if (result && pendingDelete.value) {
        try {
            const { photoId, recordId, index } = pendingDelete.value;
            await deletePatientRecordPhoto(photoId)

            // حذف از آرایه عکس‌ها
            if (files.value[recordId]) {
                files.value[recordId].splice(index, 1)
            }
        } catch (error) {
            console.error("Error deleting photo:", error)
            toast.error("خطا در حذف عکس");
        }

        pendingDelete.value = null;
    }
}

function dataURLtoBlob(dataURL) {
    const arr = dataURL.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
}

const observeRecords = () => {
    recordRefs.value = document.querySelectorAll('.record')

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const recordId = entry.target.getAttribute('data-record-id')
                    if (recordId) {
                        //loadPhotos(recordId)
                        observer.unobserve(entry.target)
                    }
                }
            })
        },
        {
            root: null,
            rootMargin: '0px',
            threshold: 0.2
        }
    )

    recordRefs.value.forEach((el, index) => {
        el.setAttribute('data-record-id', records.value[index].id)
        observer.observe(el)
    })
}

const openModal = (record) => {
    currentRecordId.value = record.id
    currentRecordTitle.value = record.title
    showModal.value = true
    showConfirmModal.value = false // مطمئن شویم confirmation modal نمایش داده نشود
}

const closeModal = () => {
    showModal.value = false
    showConfirmModal.value = false
    currentRecordId.value = null
    pendingDelete.value = null
}
const isTextEditorOpen = ref(false)

const openTextDescriptionModal = () => {
    if (patientInfo.value.doctorId === undefined || patientInfo.value.doctorId === "" || patientInfo.value.doctorId === 0) {
        toast.error("پزشک را انتخاب نمایید");
    } else {
        isTextEditorOpen.value = true
    }
}

const closeTextEditor = () => {
    isTextEditorOpen.value = false
}

const openTextEditor = (recordId, content) => {
    isTextEditorOpen.value = true
    mainContent.value = content;
    savabeghRecordId.value = recordId;

}

const saveTextDescription = () => {
    isTextEditorOpen.value = false;
    const content = textEditorRef.value.confirm();
    if (content.description !== "" || content.description != undefined) {
        addetdSavabeghText(content);
    } else {
        toast.error("هیچگونه متنی وارد نشده است")
    }
}
const addetdSavabeghText = async (data) => {
    const addSavabeghEntity = {
        fSpauto: props.patientId,
        fSradif: data.id ?? 0,
        fSdocid: patientInfo.value.doctorId,
        fSdate: "",
        fSdesc: data.description,
        fSimage: null,
        fStxuser: null,
        fStxdate: null,
        fStxtime: null,
        fStype: 0,
        fSsharh: ""
    }
    if (data.id > 0) {
        await updateSavabegh(addSavabeghEntity);

    } else {
        await addSavabegh(addSavabeghEntity);
    }
    loadRecords()
}
const openOpticalPenModal = (record) => {
    currentRecordId.value = 0; // همیشه 0 چون در PatientRecords هستیم
    currentRecordTitle.value = "نقاشی جدید";
    showOpticalPenModal.value = true
}

const closeOpticalPenModal = () => {
    showOpticalPenModal.value = false
    currentRecordId.value = null
    editingFile.value = null // پاک کردن اطلاعات ویرایش
}

const openAttachementModal = (record) => {
    currentRecordId.value = 0; // همیشه 0 چون در PatientRecords هستیم
    currentRecordTitle.value = "الصاق فایل";
    showAttachementModal.value = true
}

const closeAttachementModal = () => {
    showAttachementModal.value = false
    currentRecordId.value = null
}

const handleConfirmCamera = () => {
    showCameraModal.value = false

    // اطمینان از وجود آرایه برای recordId = 0
    if (!files.value[0]) {
        files.value[0] = []
    }

    const cameraCapture = cameraCaptureRef.value.confirm()

    // فقط اگر فایل وجود داشت
    if (cameraCapture?.photos?.length) {
        files.value[0].push(...cameraCapture.photos)
    }
}

const handleVoiceConfirm = () => {
    showVoiceRecorderModal.value = false;

    if (!files.value[0]) {
        files.value[0] = [];
    }

    const voiceRecord = voiceRecorderRef.value.confirm();

    if (!voiceRecord?.audioFile) return;

    // 👇 بدون spread
    files.value[0].push(voiceRecord.audioFile);
};


const handleScanConfirm = (data) => {
    showScanModal.value = false;
    if (!files.value[0]) {
        files.value[0] = []
    }

    // اضافه کردن فایل‌های اسکن شده
    files.value[0].push(...data.scannedFiles)
};

function handleConfirmOpticalPen(data) {
    showOpticalPenModal.value = false

    const drawingCapturecConfirm = drawingCaptureRef.value.confirm();
    // اگر در حال ویرایش فایل موجود هستیم
    if (drawingCapturecConfirm.isEditing && editingFile.value && editingFile.value.index !== undefined) {
        // جایگزین کردن فایل قدیمی با فایل جدید
        files.value[0][editingFile.value.index] = drawingCapturecConfirm.photos[0];
        editingFile.value = null; // پاک کردن اطلاعات ویرایش
    } else {
        // اطمینان از وجود آرایه برای recordId = 0
        if (!files.value[0]) {
            files.value[0] = []
        }

        // اضافه کردن فایل‌های جدید
        files.value[0].push(...drawingCapturecConfirm.photos)
    }
}
const handleAttachementConfirm = (data) => {
    showAttachementModal.value = false
    const attachementFile = uploadFileRef.value.confirm();
    // اطمینان از وجود آرایه برای recordId = 0
    if (!files.value[0]) {
        files.value[0] = []
    }

    // اضافه کردن فایل‌ها
    files.value[0].push(...attachementFile.selectedList)
}
// ✅ نمایش پیش‌نمایش و ویرایش
function viewFile(file, index) {
    console.log(file);
    if (isImage(file)) {
        // بررسی اینکه آیا این فایل یک نقاشی (drawing) است یا نه
        if (file.name === 'drawing.png' || (file.name && file.name.includes('drawing'))) {
            // اگر فایل نقاشی است، آن را برای ویرایش باز کن
            openDrawingForEdit(file, index);
        } else {
            // اگر فایل تصویر معمولی است، پیش‌نمایش نمایش بده
            previewSrc.value = getFileUrl(file);
            showPreview.value = true;
        }
    } else if (isVideo(file)) {
        console.log("نمایش ویدیو:", file.name);
    } else if (isAudio(file)) {
        console.log("پخش صوت:", file.name);
    } else if (isPDF(file)) {
        console.log("نمایش PDF:", file.name);
    }
}

// ✅ باز کردن نقاشی برای ویرایش
function openDrawingForEdit(file, index) {
    // ذخیره اطلاعات فایل فعلی برای ویرایش
    editingFile.value = { file, index, recordId: 0 }; // همیشه 0 چون در PatientRecords هستیم

    // تنظیم currentRecordId
    currentRecordId.value = 0;

    // باز کردن مودال قلم نوری
    showOpticalPenModal.value = true;
}
// متد برای دریافت تمام داده‌های لازم برای ثبت
const getSubmitData = () => {
    return {
        patientInfo: { ...patientInfo.value },
        files: files.value[0] || [],
        attachments: attachments.value,
        formData: {
            fromDate: fromDate.value,
            toDate: toDate.value,
            searchQuery: searchQuery.value
        }
    }
}

// متد برای دریافت فقط فایل‌ها
const getFiles = () => {
    return files.value[0] || []
}

// متد برای دریافت اطلاعات بیمار
const getPatientInfo = () => {
    return { ...patientInfo.value }
}

// متد برای اعتبارسنجی داده‌ها
const validateData = () => {
    const errors = []

    if (!patientInfo.value.visitDate) {
        errors.push('تاریخ مراجعه الزامی است')
    }

    if (!patientInfo.value.doctorName?.trim()) {
        errors.push('نام پزشک الزامی است')
    }

    return errors
}

// emit برای اطلاع‌رسانی تغییرات به پدر
// eslint-disable-next-line no-undef
const emit = defineEmits(['data-changed', 'view-full-records'])

// واکنش به تغییرات در patientInfo
watch(patientInfo, (newValue) => {
    emit('data-changed', { patientInfo: newValue })
}, { deep: true })

// واکنش به تغییرات در فایل‌ها
watch(() => files.value[0], (newFiles) => {
    emit('data-changed', { files: newFiles || [] })
}, { deep: true })

// eslint-disable-next-line no-undef
defineExpose({
    loadRecords,
    getSubmitData,
    getFiles,
    getPatientInfo,
    validateData
})
onMounted(() => {
    loadPatientInfo()
    loadRecords()
    loadDoctorCombo();
})
</script>

<style scoped>
.patient-records-container {
    min-height: 100vh;
    padding: 20px;
    direction: rtl;
    font-family: 'IRANSansWeb', sans-serif;
}


/* Patient Information Section */
.patient-info-section {
    background: var(--background-color);
    padding: 25px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(var(--text-color-secondary-rgb), 0.1);
    margin-bottom: 20px;
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
    transition: all 0.3s ease;
}

.form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.form-group {
    flex: 1;
}

.form-group.full-width {
    width: 100%;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: var(--text-color-thirdly);
}

.form-group input,
.form-group select,
.form-group textarea {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid var(--text-color-secondary);
    border-radius: 8px;
    transition: border-color 0.3s;
    box-sizing: border-box;
    background-color: var(--background-color);
    color: var(--text-color-primary);
}

.form-group input:focus,
.form-group textarea:focus {
    outline: none;
    border-color: var(--background-color-button);
}

.form-group input.disabled-input {
    background-color: var(--background-color-secondary);
    cursor: not-allowed;
    color: var(--text-color-secondary);
}

.form-group textarea {
    resize: vertical;
}

.calendar-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--text-color-secondary);
    pointer-events: none;
}

.clear-date-btn {
    border-radius: 30%;
    padding: 5px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-left: 5px;
    background-color: var(--background-color-danger);
    color: var(--text-color-danger);
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.clear-date-btn:hover {
    background-color: var(--background-color-danger-hover);
}

.custom-date {
    display: flex;
    align-items: center;
    gap: 2px;
    border: 1px solid var(--text-color-secondary);
    border-radius: 8px;
    background-color: var(--background-color) !important;
    transition: border-color 0.3s ease;
}

.custom-date:focus-within {
    border-color: var(--background-color-button);
}

.p-date {
    border: 1px solid var(--text-color-secondary);
    border-radius: 8px;
    text-align: start;
    overflow: hidden;
    background-color: var(--background-color);
    transition: border-color 0.3s ease;
}

.p-date:focus-within {
    border-color: var(--background-color-button);
}

.p-date :deep(.vpd-container) {
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.3);
    border-radius: 0.75rem;
    box-shadow: 0 10px 30px rgba(var(--text-color-secondary-rgb), 0.08);
    overflow: hidden;
    background-color: var(--background-color);
}

.p-date :deep(.vpd-input-group label) {
    background-color: var(--background-color-button) !important;
    color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-input-group input) {
    border: none !important;
    line-height: 32px !important;
    padding: 3px 8px;
    background-color: var(--background-color) !important;
    color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-input-group input:focus) {
    border: 1px solid transparent !important;
    outline: none !important;
}

/* استایل‌های کلندر popup برای تطبیق با تم */
.p-date :deep(.vpd-addon-list-item) {
    background-color: var(--background-color) !important;
    color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-addon-list-item:hover) {
    background-color: var(--hover-background-color) !important;
}

.p-date :deep(.vpd-addon-list-item.vpd-selected) {
    background-color: var(--background-color-button) !important;
    color: var(--text-color-forthly) !important;
}

.p-date :deep(.vpd-day) {
    color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-day:hover) {
    background-color: var(--hover-background-color) !important;
}

.p-date :deep(.vpd-day.vpd-selected) {
    background-color: var(--background-color-button) !important;
    color: var(--text-color-forthly) !important;
}

.p-date :deep(.vpd-day.vpd-today) {
    color: var(--background-color-button) !important;
    font-weight: bold;
}

.p-date :deep(.vpd-header) {
    background-color: var(--background-color-secondary) !important;
    color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-weekday) {
    color: var(--text-color-thirdly) !important;
    background-color: var(--background-color-secondary) !important;
}

.p-date :deep(.vpd-addon-list) {
    background-color: var(--background-color) !important;
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2) !important;
}

.p-date :deep(.vpd-icon-btn),
.p-date :deep(button.vpd-icon-btn),
.p-date :deep(.vpd-actions button) {
  background-color: var(--background-color-button) !important;
  color: var(--background-color) !important;
  transition: background-color 0.3s ease !important;
}

.p-date :deep(.vpd-icon-btn svg),
.p-date :deep(button.vpd-icon-btn svg),
.p-date :deep(.vpd-actions button svg),
.p-date :deep(.vpd-icon-btn svg path),
.p-date :deep(button.vpd-icon-btn svg path),
.p-date :deep(.vpd-actions button svg path) {
  fill: var(--background-color) !important;
  color: var(--background-color) !important;
  stroke: var(--background-color) !important;
}

.p-date :deep(.vpd-icon-btn:hover),
.p-date :deep(button.vpd-icon-btn:hover),
.p-date :deep(.vpd-actions button:hover) {
  background-color: var(--background-color-button-hover) !important;
}

.p-date :deep(.vpd-input-group input::placeholder) {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

/* Attachment Buttons Section */
.attachment-buttons-section {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;
}
/* 
.attachment-btn {
    background: var(--background-color-button2);
    color: var(--text-color-primary);
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
    padding: 12px 20px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    transition: all 0.3s ease;
    min-width: 120px;
    justify-content: center;
    font-family: 'IRANSans', Arial, sans-serif;
}

.attachment-btn:hover {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
    border-color: var(--background-color-button);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(var(--background-color-button-rgb), 0.15);
} */

.file-btn {
    min-width: 180px;
}

/* Filter Section */
.filter-section {
    background: var(--background-color);
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(var(--text-color-secondary-rgb), 0.1);
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
    margin-bottom: 20px;
    display: flex;
    gap: 20px;
    align-items: end;
    transition: all 0.3s ease;
}

.date-filter {
    flex: 1;
}

.date-filter label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: var(--text-color-thirdly);
}

.date-range {
    display: flex;
    gap: 10px;
}

@media screen and (max-width: 768px) {
    .filter-section {
        flex-direction: column;
        align-items: stretch;
    }

    .date-filter,
    .search-input,
    .full-records-section {
        flex: none;
        width: 100%;
        margin-bottom: 10px;
    }

}

.date-input-group {
    flex: 1;
    position: relative;
}

.date-input-group .custom-date {
    width: 100%;
}

@media screen and (max-width: 768px) {
    .date-range {
        flex-direction: column;
    }
}

.search-input {
    flex: 1;
    position: relative;
}

.full-records-section {
    display: flex;
    align-items: center;
}

.full-records-btn {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
    border: none;
    padding: 10px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    height: 40px;
    transition: all 0.2s ease;
    font-family: 'IRANSans', Arial, sans-serif;
}

.full-records-btn:hover {
    background: var(--background-color-button-hover);
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(var(--background-color-button-rgb), 0.3);
}

.search-input input {
    width: 100%;
    padding: 10px 40px 10px 16px;
    border: 1px solid var(--text-color-secondary);
    border-radius: 8px;
    font-size: 14px;
    background-color: var(--background-color);
    color: var(--text-color-primary);
    transition: border-color 0.3s ease;
}

.search-input input:focus {
    outline: none;
    border-color: var(--background-color-button);
}

.clear-search {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: var(--background-color-danger);
    color: var(--text-color-danger);
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.2s ease;
}

.clear-search:hover {
    background: var(--background-color-danger-hover);
}

/* Themed scrollbars */
.full-records-content,
.modal-content {
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
    scrollbar-width: thin;
}
.full-records-content::-webkit-scrollbar,
.modal-content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background: var(--scrollbar-track);
}
.full-records-content::-webkit-scrollbar-thumb,
.modal-content::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb);
    border-radius: 8px;
}
.full-records-content::-webkit-scrollbar-thumb:hover,
.modal-content::-webkit-scrollbar-thumb:hover {
    background: rgba(var(--text-color-secondary-rgb), 0.18);
}

.actions {
    display: flex;
    gap: 8px;
    justify-content: center;
}

.action-btn {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
}

.delete-btn {
    background: var(--background-color-danger);
    color: var(--text-color-danger);
}

.delete-btn:hover {
    background: var(--background-color-danger-hover);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(var(--background-color-danger-rgb), 0.3);
}

.edit-btn {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
}

.edit-btn:hover {
    background: var(--background-color-button-hover);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(var(--background-color-button-rgb), 0.3);
}

.view-btn {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
}

/* Image-based icons for action buttons inside tables */
.action-btn .action-icon {
    width: 18px;
    height: 18px;
    display: inline-block;
    object-fit: contain;
}

:deep(body.dark-theme) .action-btn .action-icon {
    -webkit-filter: invert(1) !important;
    filter: invert(1) !important;
}

.view-btn:hover {
    background: var(--background-color-button-hover);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(var(--background-color-button-rgb), 0.3);
}

/* Modal Styles (keeping existing) */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    -webkit-backdrop-filter: saturate(180%) blur(5px) !important;
    backdrop-filter: saturate(180%) blur(5px) !important;
}

.modal-content {
    background-color: var(--background-color);
    padding: 20px;
    border-radius: 12px;
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    overflow-y: auto;
    position: relative;
    direction: rtl;
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
    box-shadow: 0 10px 30px rgba(var(--text-color-secondary-rgb), 0.12);
}

.modal-sub-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: 0;
    background-color: var(--background-color);
    gap: 10px;
    padding: 0;
    margin-bottom: 0;
}

.sub-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    color: var(--text-color-secondary);
    width: 100%;
}

.modal-close-btn {
    border: none;
    font-size: 18px;
    color: var(--text-color-secondary);
    background-color: transparent;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color 0.2s ease;
}

.modal-close-btn:hover {
    color: var(--text-color-primary);
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
}

.large-photo {
    max-width: 90%;
    max-height: 90%;
    border-radius: 8px;
}

.image-upload-area {
    margin-top: 10px;
    margin-bottom: 10px;
    flex: 1;
    display: flex;
    justify-content: right;
    align-items: center;
    border: 2px dashed rgba(var(--text-color-secondary-rgb), 0.16);
    border-radius: 8px;
    background-color: var(--background-color-secondary);
    min-height: 20px;
    width: auto;
}

.image-placeholder {
    text-align: center;
    color: var(--text-color-secondary);
    cursor: pointer;
}

.image-placeholder span {
    font-size: 48px;
    line-height: 1;
}


.thumbnails {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-right: 7px;
    justify-content: right;
    margin-bottom: 12px;
}

.thumbnail-item {
    position: relative;
    width: 70px;
    height: 70px;
    border: 2px solid rgba(var(--text-color-secondary-rgb), 0.2);
    border-radius: 6px;
    cursor: pointer;
    margin-left: 7px;
}

.thumbnail-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}


.delete-file-btn {
    position: absolute;
    top: -8px;
    right: -8px;
    background-color: var(--background-color-danger);
    color: var(--text-color-danger);
    border: none;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    cursor: pointer;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 5px rgba(var(--text-color-secondary-rgb), 0.3);
    transition: background-color 0.3s ease;
}

.delete-file-btn:hover {
    background-color: var(--background-color-danger-hover);
}

.delete-file-btn svg {
    width: 12px;
    height: 12px;
}

.preview-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(var(--text-color-secondary-rgb), 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.icon-center {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--text-color-secondary);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 20px;
    cursor: default;
}

.header-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.header-buttons {
    display: flex;
    gap: 8px;
}
/* 
.confirm-btn,
.cancel-btn {
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
} */

/* .confirm-btn {
    background-color: var(--background-color-button);
    color: var(--text-color-forthly);
} */

/* .confirm-btn:hover {
    background-color: var(--background-color-button-hover);
} */
/* 
.cancel-btn {
    background-color: var(--background-color-button2);
    color: var(--text-color-primary); 
    border: none;
} */

/* .cancel-btn:hover {
    background-color: var(--background-color-button-hover2);
} */

.header-right {
    display: flex;
    align-items: center;
}

.header-left {
    display: flex;
    gap: 10px;
}

.btn {
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
}

.btn-success {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
}

.btn-secondary {
    background: var(--background-color-button2);
    color: var(--text-color-primary);
}

.confirm-content {
    text-align: center;
    padding: 20px;
}

.confirm-buttons {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 20px;
}

.btn-confirm {
    background: var(--background-color-danger);
    color: var(--text-color-danger);
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.btn-cancel {
    background: var(--background-color-button2);
    color: var(--text-color-primary);
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

/* Responsive Design */
@media (max-width: 768px) {
    .patient-records-container {
        padding: 10px;
    }

    .form-row {
        flex-direction: column;
        gap: 15px;
    }

    .attachment-buttons-section {
        flex-direction: column;
    }

    .attachment-btn {
        width: 100%;
    }

    .filter-section {
        flex-direction: column;
        gap: 15px;
    }

    .action-btn {
        flex: 1;
        width: auto;
        height: auto;
        padding: 8px 16px;
        min-width: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .action-btn svg,
    .action-btn .fa-icon {
        margin-left: 6px;
    }
}

/* استایل مودال نمایش کامل سوابق */
.full-records-modal-content {
    background: var(--background-color);
    border-radius: 12px;
    max-width: 90vw;
    max-height: 90vh;
    width: 600px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.full-records-modal-content .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 25px;
    border-bottom: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
    background: var(--background-color-secondary);
}

.full-records-modal-content .modal-header h3 {
    margin: 0;
    color: var(--text-color-thirdly);
    font-size: 18px;
    font-weight: 600;
}

.header-buttons {
    display: flex;
    gap: 10px;
    align-items: center;
}

.print-btn {
    background: var(--background-color-button2);
    color: var(--text-color-primary);
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.3);
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    font-family: 'IRANSans', Arial, sans-serif;
}

.print-btn:hover {
    background: var(--background-color-button-hover2);
    border-color: var(--text-color-secondary);
}

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    color: var(--text-color-secondary);
    cursor: pointer;
    padding: 5px;
    line-height: 1;
    transition: color 0.2s ease;
}

.close-btn:hover {
    color: var(--text-color-primary);
}

.full-records-content {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
}

.no-records {
    text-align: center;
    color: var(--text-color-secondary);
    font-size: 16px;
    padding: 40px;
}

.records-grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.record-item {
    border: 1px solid rgba(var(--text-color-secondary-rgb), 0.2);
    border-radius: 8px;
    background: var(--background-color);
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(var(--text-color-secondary-rgb), 0.1);
    transition: all 0.2s ease;
}

.record-item:hover {
    box-shadow: 0 4px 8px rgba(var(--text-color-secondary-rgb), 0.15);
}

.record-header {
    background: var(--background-color-secondary);
    padding: 15px;
    border-bottom: 1px solid rgba(var(--text-color-secondary-rgb), 0.15);
    display: flex;
    align-items: center;
    gap: 10px;
}

.record-number {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
}

.record-type {
    font-weight: 600;
    color: var(--text-color-thirdly);
    flex: 1;
}

.record-date {
    font-size: 12px;
    color: var(--text-color-secondary);
}

.record-content {
    padding: 15px;
}

.record-content h4 {
    margin: 0 0 10px 0;
    color: var(--text-color-thirdly);
    font-size: 14px;
    font-weight: 600;
}

.text-content p {
    margin: 0;
    line-height: 1.5;
    color: var(--text-color-primary);
    background: var(--background-color-secondary);
    padding: 10px;
    border-radius: 4px;
}

.image-content,
.drawing-content {
    text-align: center;
}

.image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.image-preview-wrapper,
.drawing-preview-wrapper {
    display: inline-block;
    border-radius: 8px;
    overflow: hidden;
    max-width: 100%;
}

.image-preview-wrapper img,
.drawing-preview-wrapper img {
    max-width: 100%;
    max-height: 200px;
    border-radius: 8px;
    display: block;
}

.zoom-btn {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    font-family: 'IRANSans', Arial, sans-serif;
}

.zoom-btn:hover {
    background: var(--background-color-button-hover);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(var(--background-color-button-rgb), 0.3);
}

.image-buttons,
.audio-buttons,
.file-buttons {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
}



.image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background: var(--background-color-secondary);
    border: 2px dashed rgba(var(--text-color-secondary-rgb), 0.3);
    border-radius: 8px;
    color: var(--text-color-secondary);
    min-height: 120px;
}

.image-placeholder svg {
    font-size: 32px;
    margin-bottom: 10px;
    opacity: 0.5;
    color: var(--text-color-secondary);
}

.image-placeholder span {
    font-size: 14px;
}

.play-audio-btn {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    font-family: 'IRANSans', Arial, sans-serif;
}

.play-audio-btn:hover {
    background: var(--background-color-button-hover);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(var(--background-color-button-rgb), 0.3);
}

.download-btn {
    background: var(--background-color-success);
    color: var(--text-color-forthly);
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    font-family: 'IRANSans', Arial, sans-serif;
}

.download-btn:hover {
    background: var(--background-color-success-hover);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(var(--background-color-success-rgb), 0.3);
}

.record-actions {
    padding: 10px 15px;
    border-top: 1px solid rgba(var(--text-color-secondary-rgb), 0.15);
    background: var(--background-color-secondary);
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

.record-actions .action-btn {
    background: var(--background-color-button2);
    color: var(--text-color-primary);
    border: none;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;
}

    .record-actions .download-btn {
    background: var(--background-color-success);
    color: var(--text-color-forthly);
}

.record-actions .view-btn {
    background: var(--background-color-button);
    color: var(--text-color-forthly);
}

.record-actions .play-btn {
    background: var(--background-color-warning);
    color: var(--text-color-primary);
}

.record-actions .action-btn:hover {
    opacity: 0.8;
    transform: translateY(-1px);
}

@media (max-width: 768px) {
    .full-records-modal-content {
        width: 95vw;
        margin: 10px;
    }
    
    .record-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
}
</style>